async function getLivewireToken() {
    const response = await fetch('/csrf', {
        credentials: 'same-origin',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    });

    return await response.json();
}

function applyCsrfToken(token) {
    if (!token) {
        return;
    }

    if (typeof window !== 'undefined' && typeof window.__vsebankiApplyCsrfToken === 'function') {
        window.__vsebankiApplyCsrfToken(token);
        return;
    }

    let meta = document.head.querySelector('meta[name="csrf-token"]');

    if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'csrf-token';
        meta.id = 'csrf-token';
        document.head.appendChild(meta);
    }

    meta.setAttribute('content', token);

    if (typeof window !== 'undefined') {
        window.livewireScriptConfig = window.livewireScriptConfig || {};
        window.livewireScriptConfig.csrf = token;
    }

    document.querySelectorAll('input[name="_token"]').forEach((input) => {
        input.value = token;
    });
}

async function syncCsrfTokenMeta() {
    try {
        if (typeof window !== 'undefined' && typeof window.__vsebankiEnsureCsrfToken === 'function') {
            await window.__vsebankiEnsureCsrfToken();
            return;
        }

        const data = await getLivewireToken();

        if (!data.token) {
            return;
        }

        applyCsrfToken(data.token);
    } catch (error) {
        console.error('Failed to sync CSRF token meta tag:', error);
    }
}

const bootstrapCsrfMetaSync = () => {
    if (typeof window !== 'undefined' && window.__vsebankiLivewireManualStartEnabled) {
        return;
    }

    void syncCsrfTokenMeta();
};

if (typeof document !== 'undefined') {
    document.addEventListener('livewire:load', bootstrapCsrfMetaSync, { once: true });
}

if (typeof window !== 'undefined') {
    window.addEventListener('livewire:load', bootstrapCsrfMetaSync, { once: true });

    if (window.Livewire) {
        bootstrapCsrfMetaSync();
    }
}
